<template>
  <section
    :class="[
      'tabs-wrap',
      { de_s: storeName.DE_s, fr: storeName.FR, ee: storeName.EE },
    ]"
  >
    <div v-if="storeLogo" class="logo-wrap">
      <img :src="storeLogo" :alt="logoAlt" />
    </div>
    <nav class="foot-tabs" v-if="footTabs">
      <span
        v-for="item in footTabs"
        @click="changeCurrentId(item.id)"
        :class="[item.id == currentId ? 'active' : '']"
        :key="item.id"
      >
        {{ item.name }}
      </span>
    </nav>
    <transition name="showMenu-pc" mode="out-in">
      <template v-if="storeName.FR">
        <div class="tabs-content" v-if="currentId == 1" key="paiement">
          <h3>
            Nous acceptons les paiements suivants.
          </h3>
          <p>1. Paypal.</p>
          <p>
            2. Carte de crédit / débit. Nous préparerons les commandes dès la
            réception du paiement.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 2" key="livraison">
          <ul>
            <li>
              Nous vous garantirons l’expédions de votre article par nos
              transporteurs spécialisés dans un délais d’1 jour ouvrable si le
              paiement est effectué avant 10 heures.
            </li>
            <li>
              Le paiement effectué après 10h sera envoyé le jour ouvrable
              suivant. Si vous n'êtes pas présent lorsque la livraison a été
              tentée, des frais d'affranchissement supplémentaires peuvent être
              facturés avant que nous puissions renvoyer l'article.
            </li>
            <li>
              Si vous refusez ensuite de recevoir l'article après une tentative
              de livraison, des frais de retour de 25 euros seront déduits de
              votre remboursement. Nous ne pouvons pas changer l'adresse de
              livraison une fois la commande passée.
            </li>
            <li>
              Nous ne pouvons pas mettre de commande en attente. Si vous
              souhaitez recevoir la commande plus tard, il serait préférable de
              commander à une heure proche.
            </li>
            <li>
              Dans le cas peu probable où vous ne recevriez pas vos objets à la
              date prévue, veuillez nous contacter avant d’ouvrir une demande
              eBay afin que nous puissions traiter votre question plus
              efficacement.
            </li>
            <li>
              Veuillez noter que le service de courrier ne peut livrer vos
              articles à votre porte que si vous êtes au rez-de-chaussée. Frais
              de port gratuits dans la plupart des régions de la France,
              cependant, si vous tombez dans les codes postaux ou les zones
              suivantes, vous devrez payer des frais de port ci-dessous.
            </li>
          </ul>
          <div class="table">
            <ul class="tr">
              <li class="th">Zones</li>
              <li class="th">Frais de port</li>
            </ul>
            <ul class="tr">
              <li class="td">Corse</li>
              <li class="td">20,9 € / Colis</li>
            </ul>
            <ul class="tr">
              <li class="td">Iles Français</li>
              <li class="td">7 € / Colis</li>
            </ul>
            <ul class="tr">
              <li class="td">Zones montagneuses</li>
              <li class="td">3,5 € / Colis</li>
            </ul>
          </div>
        </div>
        <div class="tabs-content" v-if="currentId == 3" key="retour">
          <p>
            Une fois que vous avez reçu l'article en bon état et que vous êtes
            satisfait de nos produits ainsi que de notre service, merci de nous
            laisser un commentaire positif avec 5 étoiles. Dans le cas peu
            probable où vous ne seriez pas satisfait de nos produits ou
            services, veuillez nous appeler / nous envoyer un email avant de
            laisser des commentaires, nous ferons alors tout notre possible pour
            résoudre le problème à votre place.
          </p>
          <p>
            Dans le cas peu probable où votre article serait défectueux,
            veuillez nous le signaler dans les 7 jours ouvrables suivant votre
            commande. Nous aurions besoin d'une photo ou d'une vidéo montrant
            clairement le problème, nous pouvons ensuite vous envoyer des pièces
            pour résoudre le problème dès que possible. Si l'article n'est pas
            réparable, nous vous enverrons immédiatement un remplaçant.
          </p>
          <p>Si vous avez changé d'avis</p>
          <p>
            vous souhaitez retourner l'article, envoyez-nous un message via eBay
            dans les 30 jours suivant l'achat. Nous pouvons alors vous
            conseiller sur la procédure de retour.
          </p>
          <p>
            Si vous retournez l’article par vous-même, merci de bien protéger
            les produits dans ses emballages originaux, nous vous suggérons
            d’utiliser un service de messagerie qui pourra vous dédommager, car
            nous ne prenons aucune responsabilité pour les objets endommagés ou
            perdus pendant le transport.
          </p>
          <p>
            Une fois que l'article nous a été livré en bon état et dans son
            emballage d'origine (non ouvert), nous vous rembourserons dans les 5
            jours ouvrables. Si l'emballage n'est pas acceptable ou si certaines
            pièces sont endommagées ou manquantes, nous ne pourrons déterminer
            qu'un remboursement partiel. N’oubliez pas de nous envoyer un
            message avec les informations de suivi via eBay une fois que vous
            expédiez l'article.
          </p>
          <p>
            Nous pouvons collecter pour votre compte à un coût
            supplémentaire.Les frais de collecte pour les articles sont de 30 et
            de 100 selon les articles. Ils devront être payés avant que nous
            puissions organiser la collecte. Cette taxe est pour 1 tentative de
            collecte seulement. Si le service de messagerie confirme que la
            collecte a échoué du fait que le client n’est pas à la maison ou les
            articles ne sont pas prêts, vous devrez effectuer un autre paiement.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 4" key="après vente">
          <p>
            Nous avons une équipe d’assistance client expérimentée qui est là
            pour accompagner chaque achat à chaque étape. Nos sympathiques
            représentants à la clientèle sont ici pour répondre à toutes vos
            questions, de la demande initiale au conseil après-vente.
          </p>
          <p>
            Nos produits sont couverts par une garantie à vie sauf indication
            contraire - à l'exclusion des bris de verre
          </p>
          <p>Si vous avez trouvé des dégats</p>
          <p>
            Cela devra nous être signalé dans les 7 jours ouvrables suivant
            votre achat. Nous demanderons une photo ou une vidéo pour prouver
            que l'article est endommagé ou défectueux, ainsi qu'un numéro de
            pièce indiqué dans les instructions, puis nous vous enverrons la
            pièce requise. Si nous envoyons le numéro de pièce que vous
            demandez, mais que ce n'est pas le bon, des frais de port seront
            facturés pour nous permettre de renvoyer une autre pièce. Toutes les
            pièces doivent être demandées en premier lieu si demandé séparément,
            des frais de port sont facturés. S'il vous plaît ne pas réserver un
            plombier à l'avance - Nos articles doivent être installés par un
            plombier spécialisé. Nous ne remboursons strictement aucun coût /
            facture de plombier ni aucun autre coût à un retard de livraison,
            car la livraison n’est pas sous notre contrôle. Veuillez donc ne
            réserver un plombier qu'après avoir reçu les articles et vérifié
            qu'ils sont en bon état.
          </p>
          <p>Des installations</p>
          <p>
            Les installations et les temps d’instruction peuvent varier en
            fonction des compétences de la personne qui les installe. Nous ne
            sommes pas responsables du temps pris mais nous pouvons fournir une
            assistance.
          </p>
        </div>
      </template>
      <template v-if="storeName.DE_s">
        <div class="tabs-content" v-if="currentId == 1" key="zahlung">
          <p>Wir akzeptieren Zahlungen per Überweisung und PayPal:</p>
          <h3>PayPal</h3>
          <p>
            Zahlen Sie einfach, schnell und sicher mit PayPal.<br />
            Der Betrag wird schnellstmöglich gutgeschrieben und erlaubt uns
            sofortige Bestellbearbeitung.
          </p>
          <h3>Überweisung (Vorkasse)</h3>
          <p>
            Wenn Sie die Zahlungsart Überweisung wählen, überweisen Sie den
            Kaufbetrag bitte nach Abschluss der Kaufabwicklung auf unser
            Bankkonto:
          </p>
          <p>
            Kontoinhaber: Sonni Sanitär GmbH<br />
            Bankinstitut: Deutsche Bank<br />
            IBAN: DE53 2007 0024 0066 2643 00<br />
            BIC: DEUTDEDBHAM<br />
            Als Verwendungszweck geben Sie bitte Ihren eBay-Mitgliedsnamen an.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 2" key="lieferung">
          <p>
            Der Versand erfolgt, sobald wir einen Zahlungseingang feststellen
            können.
          </p>
          <p>
            Wir versenden mit DPD. Die Lieferzeit beträgt bei Paketen innerhalb
            Deutschlands 1-2 Werktage nach Zahlungseingang.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 3" key="bewertung">
          <p>
            Wenn Sie mit unserer Leistung zufrieden sind, vergessen Sie bitte
            nicht uns auch in den detaillierten Verkäuferbewertungen jeweils mit
            100% zu bewerten.
          </p>
          <p>
            Sollte es irgendwelche Beanstandungen Ihrerseits geben, bitten wir
            Sie höflichst, uns vor der Abgabe der Bewertung zu kontaktieren,
            damit wir eine schnellstmögliche Lösung für Sie finden können.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 4" key="rechnung">
          <p>
            Die Rechnung wird automatisch generiert und an den Kunden per Email
            gesendet.
          </p>
          <p>
            Bitte prüfen Sie hierzu nochmals Ihre hinterlegte Emailadresse.
          </p>
        </div>
      </template>
      <template v-if="storeName.EE">
        <div class="tabs-content" v-if="currentId == 1" key="Shipping">
          <p>
            1. To save yourself time and reduce delays, fees and hassles , make
            sure you insert the correct delivery address and the correct
            product/quantity you require at the point of purchase.
          </p>
          <p>
            2. Items ordered before 10am will be dispatched on the same day,
            items ordered after 10 am will be sent on the next working day.
            Delivery time may vary depending on what items you have ordered.
            Please message us should you have any questions on this. Also, we
            are unable to place any orders on hold as per eBay terms and
            conditions.
          </p>
          <p>
            3. If you are not in when delivery has been attempted there may be
            an extra postage charge incurred before we can resend the item. If
            you then refuse to have the item after deliveries have been
            attempted the £25 return charges will be deducted from your refund.
          </p>
          <p>
            4. Please be aware that the courier service can only deliver your
            items to your front door providing that you are on the ground floor.
          </p>
          <p>
            5. Free postage to most areas in UK , however If you fall into the
            following postcodes or areas, you will need to pay postage. In the
            unlikely event that the postage isn't calculated at checkout please
            let us know.
          </p>
          <div class="table">
            <ul class="tr">
              <li class="td">Fee</li>
              <li class="td">Postcodes</li>
            </ul>
            <ul class="tr">
              <li class="td full">Free postage to mainland UK</li>
            </ul>
            <ul class="tr">
              <li class="td">￡299</li>
              <li class="td">PO30-41</li>
            </ul>
            <ul class="tr">
              <li class="td">￡299</li>
              <li class="td">BT</li>
            </ul>
            <ul class="tr">
              <li class="td">￡299</li>
              <li class="td word-break">
                IV,KW1 - 14,PA34, PA37-39 PH19-40, PH49-50 PH41, IM,
                PA20,PA31,PA35,PA41+,KA27,TR21-25
              </li>
            </ul>
            <ul class="tr">
              <li class="td">Areas we don't post to</li>
              <li class="td">JE,GY,ZE,HS</li>
            </ul>
          </div>
        </div>
        <div class="tabs-content" v-if="currentId == 2" key="Return">
          <h3 style="font-size: 1em;">WRONG ITEM ORDERED OR CHANGE MIND</h3>
          <p>
            Please message us via eBay within 14 days after the purchase. We can
            then advise on the return procedure.
          </p>
          <p>
            We can arrange collection on your behalf at a cost of £39 for single
            item and £78 for multiple items with an extra £15 per item that has
            been opened. This would cover you for any damages or loss that may
            occur during transit.
          </p>
          <p>
            Alternatively you can arrange your own courier but please make sure
            that the courier would provide you with tracking information and
            also cover you for the cost of any damages or loss as we would not
            be held liable. Once the item has been returned we will assesss the
            return condition
          </p>
          <h3 style="font-size: 1em;">FAULTY ITEM</h3>
          <p>
            In the unlikely event that your item is faulty please report the
            fault to us within 7 working before you start a return procedure. We
            would require a photo or video showing the fault clearly to provide
            assistance.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 3" key="Aftersales">
          <h3 style="font-size:1em">ITEM DAMAGED OR NOT RECEIVED</h3>
          <p>
            Any damage or shortage of items upon delivery must be reported to
            our customer service team within 7 days to be validated. Photos may
            be required. Goods that have been fitted or installed will not be
            considered for return unless there is a manufacturing defect; the
            relevant product guarantee then applies.
          </p>
          <h3 style="font-size:1em">
            PRODUCT SPECIFICATION TERMS & CONDITIONS
          </h3>
          <p>
            As a continually evolving company, we reserve the right to change
            product specifications without prior notice. Due to this, we advise
            no installation preparation takes place prior to receiving the
            product.
          </p>
          <p>
            Product colours & finishes represented online and on the actual
            product might differ slightly.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 4" key="Feedback">
          <p>
            If you are satisfied with the product and customer care received
            please write a feedback of your experience with us.
          </p>
          <p>
            In the unlikely event that you are not satisfied, please contact us
            before leaving any feedback, we will then do our utmost to solve
            problem for you.
          </p>
        </div>
        <div class="tabs-content" v-if="currentId == 5" key="Notice">
          <p>
            Please kindly note that delays could potentially occur as couriers
            have encountered operational issues due to COVID-19, resulting in
            some items not being scanned and delays to deliveries. We are
            working to prioritise delivery for essential services.
          </p>
          <p>
            Your help and understanding will allow us to continue to support
            essential services across the United Kingdom during this national
            crisis.
          </p>
          <p>
            **Effective immediately and until further notice - Our TNT delivery
            service may be impacted due to COVID-19
          </p>
        </div>
      </template>
    </transition>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "foot-nav",
  data() {
    return {
      currentId: 1,
    };
  },
  props: {
    footTabs: {
      type: Array,
      required: true,
    },
    storeLogo: {
      type: String,
      required: false,
    },
    logoAlt: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
  methods: {
    changeCurrentId(targetId) {
      this.currentId = targetId;
    },
  },
};
</script>

<style lang="less" scoped>
.tabs-wrap {
  .mx(auto);
  &.fr {
    .tabs-content {
      .table {
        .wh(90%, auto);
      }
    }
  }
  &.de_s {
    > .foot-tabs {
      > span {
        .t-t;
      }
    }
  }
  &.ee {
    .flex-wrap(initial, center, wrap);
    width: 90%;
    .pt(2rem);
    @media (min-width: 576px) {
      .logo-wrap {
        flex: 0 0 26%;
      }
      .foot-tabs {
        .ml(4rem);
        .mr(2rem);
        flex: 1;
        > span {
          .fz(1.4rem);
          .t-t;
          color: @ExtraLight;
        }
      }
      .table {
        width: 60%;
      }
    }
    @media (max-width: 576px) {
      .logo-wrap {
        flex: 0 0 80%;
        .mx(auto);
      }
      .foot-tabs {
        flex: 1;
      }
    }
    .tabs-content {
      color: @ExtraLight;
    }
    .table {
      .mx(0);
      > .tr {
        > .td {
          justify-content: initial;
          text-align: left;
          &:first-child {
            flex: 0 0 28%;
          }
          &.full {
            flex: 1;
          }
        }
      }
    }
    h3 {
      color: @primaryColor;
    }
  }
  @media (min-width: 576px) {
    &.fr {
      width: 1170px;
    }
    &.de_s {
      width: 940px;
    }
  }
  @media (max-width: 576px) {
    width: 90%;
  }
  .foot-tabs {
    @media (min-width: 576px) {
      .flex-wrap(space-between);
    }
    @media (max-width: 576px) {
      .flex-wrap(center, center, initial, column);
      .bg-c(rgba(255, 255, 255, 0.849), #2a2d34);
      .py;
    }
    .my;
    .py(1.2em);
    > span {
      .lh;
      .fz;
      .cur;
      .t-t(uppercase);
      position: relative;
      .gd(0.6s);
      &:after {
        content: "";
        display: block;
        position: absolute;
        @media (max-width: 576px) {
          left: 50%;
          transform: translateX(-50%);
        }
        .mx(auto);
        text-align: center;
        width: 0;
        .gd(0.8s);
        .border-B(@primaryColor, 4px);
      }
      &.active {
        color: @primaryColor;
        &::after {
          width: 100%;
        }
      }
    }
    & ~ div {
      .mt;
    }
  }
  .tabs-content {
    height: 350px;
    overflow: auto;
    > ul {
      .pl(1.5rem);
      li {
        list-style: initial;
      }
    }
    .fz(1rem);
    .table {
      .th,
      .td {
        color: @primaryColor;
        .lh;
        text-align: center;
        .flex-wrap;
      }
    }
    h3,
    p {
      .my;
    }
    h3 {
      color: @primaryColor;
    }
  }
  .showMenu-leave-active,
  .showMenu-enter-active {
    transition: all 0.3s;
  }
}
</style>
